import React from "react";
import { TableContentForEmployeeSessionImageReport } from '../../../Common/Table/tableContent';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const reportData = this.props.data;
        const contentRowNames = this.props.rowNames;
        const tableHeaders = this.props.tableHeaders;

        return (
            <div>
                <h3><center><u>Employee Image Session Report</u></center></h3>
                <div className="row pb-4 pt-4 pl-2">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Operation Entity: </b> {searchData.estate}</div>
                    <div className="col"><b>Collection Point: </b> {searchData.division}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>

                <div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="table-responsive row-top-gap">
                                <table className="display dataTable no-footer" style={{ width: "100%" }}>
                                    <thead>
                                        <tr>
                                            {
                                                tableHeaders.map((x, index) => {
                                                    return (
                                                        <th key={index}>{x}</th>
                                                    );
                                                })
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <TableContentForEmployeeSessionImageReport
                                            data={reportData}
                                            contentRowNames={contentRowNames}
                                            hasEdit={false}
                                        />
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}